export const muiAppBarTheme = {
  MuiAppBar: {
    styleOverrides: {
      root: {
        height: 88,
        justifyContent: 'center',
      },
    },
  },
};
